import styled from 'styled-components'
import { PopoverContainer } from '../../../../popover/styles'

export const UserPopoverContainer = styled(PopoverContainer)`
  position: absolute;
  right: 0;
  top: 63px;
`